// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1wxqD","footer":"ReportModalFilter_footer__3IWyO"};